// extracted by mini-css-extract-plugin
export var categoryHeading = "menuItems-module--categoryHeading--ssuGY";
export var center = "menuItems-module--center--5f2Sw";
export var flex = "menuItems-module--flex--ommjW";
export var hideOnDesktop = "menuItems-module--hideOnDesktop--dj9Ih";
export var image = "menuItems-module--image--4IiyI";
export var img = "menuItems-module--img--lH6kJ";
export var itemDescription = "menuItems-module--itemDescription--4a3yi";
export var itemName = "menuItems-module--itemName--7XC-X";
export var mM = "menuItems-module--m-m--Je80M";
export var mbM = "menuItems-module--mb-m--lkVyp";
export var menuItem = "menuItems-module--menuItem--td8O6";